import { render } from "./RecentlyViewed.vue?vue&type=template&id=157dc0cd&scoped=true"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"

import "./RecentlyViewed.vue?vue&type=style&index=0&id=157dc0cd&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157dc0cd"]])

export default __exports__